import React from 'react'
import { Row, Table, Col, Card, CardHeader, CardBody } from 'reactstrap'
import { Link } from 'react-router-dom'

/*

Pane where can select which user to view assignments as

When you click an assignment, you go to working on it on the "Work Assignments" tab

*/

export default function AssignmentsView (props) {
  let assignmentRows = <tr></tr>
  if (props.activeUserAssignments) {
    if (props.activeUserAssignments === {}) {
      assignmentRows = <tr><td>No assignments yet.</td><td></td></tr>
    } else {
      const assignmentKeys = Object.keys(props.activeUserAssignments)
      assignmentRows = assignmentKeys.map( (assignmentKey, n) => {
        let grade = 'Not Started'
        if (props.activeUserAssignments[assignmentKey].grade === -1) {
          grade = 'In Progress, No Grade Yet'
        } else if (props.activeUserAssignments[assignmentKey].grade) {
          grade = (props.activeUserAssignments[assignmentKey].grade * 100) + '%'
        }
        return (
          <tr key={'assignmentRow' + n} >
            <td><Link to={'/assignments/assignment/' + assignmentKey}>{props.assignments[assignmentKey].assignmentName}</Link></td>
            <td>{grade}</td>
          </tr>
        )
      })
    }
  }
    
  
  return (
    <Row>
      <Col>
        <Card>
          <CardHeader>
            Your Assignments
          </CardHeader>
          <CardBody>
            <Table>
              <thead>
                <tr>
                  <th>Assignment Name</th>
                  <th>Grade</th>
                </tr>
                {assignmentRows}
              </thead>
            </Table>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}



/*

onClick={() => props.openAssignment(props.activeUserAssignments[assignmentKey])}

*/


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentsView.js